import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/**
 * The contact import running in the background, if any. It lives outside the
 * import dialog so closing the dialog (or reloading the page) does not lose
 * track of it: the contacts page follows it to the end and reports once.
 * Tagged with its tenant so another tenant's session never polls it.
 */
interface ContactImportState {
  active: { jobId: string; tenantId: string | null } | null;
  track: (jobId: string, tenantId: string | null) => void;
  /** Stops tracking `jobId` (a newer import is left alone). */
  finish: (jobId: string) => void;
}

export const useContactImportStore = create<ContactImportState>()(
  persist(
    (set) => ({
      active: null,
      track: (jobId, tenantId) => set({ active: { jobId, tenantId } }),
      finish: (jobId) => set((state) => (state.active?.jobId === jobId ? { active: null } : state)),
    }),
    {
      name: 'notifi-contact-import',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
